import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import $script from 'scriptjs';

const LoadRemoteComponent = ({ url, name, props, children }) => {
  const [Component, setComponent] = useState(null);

  useEffect(() => {
    // Expose React for UMD build
    window.React = React;
    window.ReactDOM = ReactDOM;

    // Async load of remote UMD component
    $script(url, () => {
      const target = window[name];
      if (target) {
        // Loaded successfully
        setComponent(() => target);
      } else {
        // Failed to load
        setComponent(null);
      }
    });

    // Cleanup function to remove global React references
    return () => {
      delete window.React;
      delete window.ReactDOM;
    };
  }, [url, name]);

  if (Component) {
    return React.createElement(Component, props);
  }

  return children;
};

export default LoadRemoteComponent;
